import { EventAggregator } from "oj-eventaggregator";
import { ActorType, Actor } from "./actor/base";
export class Director extends EventAggregator {
    _actors;
    _timer;
    stopped = true;
    _input;
    constructor() {
        super();
        this._actors = new Set();
    }
    register(...actors) {
        for (const actor of actors) {
            if (actor instanceof Actor)
                this._actors.add(actor);
            else
                this.register(...Object.values(actor));
        }
        return this;
    }
    input(fn) {
        this._input = fn;
    }
    start() {
        if (!this.stopped)
            return;
        this.emit("start", this);
        this.stopped = false;
        let i = 0;
        let apply = true;
        let prev;
        const animate = () => {
            let now;
            if (typeof this._input === "function") {
                now = this._input(i);
                apply = prev !== now;
                prev = now;
                if (apply) {
                    i++;
                }
            }
            else {
                now = Date.now();
            }
            if (apply) {
                let done = true;
                for (const actor of this._actors) {
                    actor.update(now);
                    if (!actor.done)
                        done = false;
                }
                this.emit("update", this);
                if (this._actors.size === 0)
                    done = true;
                if (done)
                    this.stop();
            }
            if (!this.stopped)
                this._timer = requestAnimationFrame(animate);
        };
        animate();
        return this;
    }
    stop() {
        this.stopped = true;
        cancelAnimationFrame(this._timer);
        this.emit("stop", this);
        return this;
    }
    destroy() {
        this.stop();
        this._actors.forEach(x => x.destroy());
        return this;
    }
}
